import * as ts from "../../common/Translator";
import {translate, translateId} from "../../common/Translator";
import {isNullOrUndefined, nextId} from "../../common/NamaCommon";
import * as EditScreenFieldLayout from "../../constants/EditScreenFieldLayout";
import * as meta from "../../common/Metadata";
import {findFieldMetadata} from "../../common/Metadata";
import {getEntityImageInfo, isFeatureEnabled, shouldShowHelpMsgs} from "../../login/ClientCache";
import {userCanViewField} from "../../login/Security";
import {getFieldWidth, intiWidget_} from "../../widgets/FieldWidgetCreator";
import {isMobileDevice, shouldAddMainFileWidget} from "../../common/GUIUtilities";
import {AttachmentWidget} from "../../widgets/AttachmentWidget";
import {createFieldMetadata} from "../../common/ExpressionEditUtility";
import {findHelpMsgAndShowIt} from "../../common/ErrorsNotification";
import * as FieldType from "../../constants/FieldType";

export class EditScreenGroup {
    constructor(group, metaData, presenter) {
        this.group = group;
        this.metaData = metaData;
        this.presenter = presenter;
    }

    drawGroup(group, metaData, presenter, groupNumber) {
        let that = this;
        let container = that.createGroupContainer(group.title, presenter);
        let widgetsList = container.find(".widgetsList");
        if (!that.groupHandler)
            that.groupHandler = new EditScreenGroupHandler(widgetsList, that.rootElement);
        if (!group.fields)
            return container;
        for (let field of group.fields) {
            that.renderField({field, metaData, presenter, widgetsList, groupNumber: groupNumber});
        }
        return widgetsList.html() && widgetsList.find(".widgetContainer").length ? container : null;
    }

    shouldAddMainFileContainer(presenter) {
        let that = this;
        let isFirstGroup = presenter.noGroupsAdded;
        if (!isFirstGroup)
            return false;
        return isFirstGroup && shouldAddMainFileWidget(presenter.entityType);
    }


    createGroupContainer(title, presenter) {
        let that = this;
        let groupTitle = $.trim(ts.translateNaMaText(title)) || "&nbsp;";
        let groupId = title ? title.resourceId : nextId();
        let container = $(`<li class="k-state-active" id="${groupId}"><span>${groupTitle}</span></li>`);
        if (!presenter)
            container = $(`<li class="k-state-active k-item k-first k-state-highlight" id="${groupId}" role="menuitem" aria-expanded="true"><span class="k-link k-header gridLineEditorHeader"><span>${groupTitle}</span><span class="k-icon k-panelbar-collapse k-i-arrow-60-up"></span></span></li>`);
        if (presenter && that.shouldAddMainFileContainer(presenter)) {
            let groupAndImgContainer = $(`<div id = "groupImgContainer" class="row"><div class="widgetsList col-md-8"></div>
            <div id ="mainFileContainer" class="col-md-4"></div></div>`);
            let mainFileWidthPercent = calcMainFileWidthPercent(presenter.entityType);
            if (mainFileWidthPercent) {
                let remaining = 100 - mainFileWidthPercent;
                groupAndImgContainer.find("#mainFileContainer").removeClass("col-md-4");
                groupAndImgContainer.find("#mainFileContainer").width(mainFileWidthPercent + "%");
                groupAndImgContainer.find(".widgetsList").width(remaining + "%");
                groupAndImgContainer.find(".widgetsList").removeClass("col-md-8");
            }
            let fieldMetadata = findFieldMetadata("mainFile", presenter.metaData);
            let mainFileWidget = new AttachmentWidget({owner: presenter, fieldMetadata, id: "mainFile"});
            presenter.addDataWidget(mainFileWidget);
            mainFileWidget.render().appendTo(groupAndImgContainer.find("#mainFileContainer"));
            container.append(groupAndImgContainer);
        } else {
            let widgetList = $(`<div class="widgetsList"></div>`);
            container.append(widgetList);
        }
        return container;

    }

    renderField({field, metaData, presenter, widgetsList, compositeField, groupNumber, isFirstCompositePart, subFieldsLength}) {
        let that = this;
        if (field.subFields && field.subFields.length) {
            that.drawCompositeField(field, metaData, presenter, widgetsList, groupNumber);
        } else {
            that.groupHandler.addWidget(field, metaData, presenter, that.findMetadata(field), compositeField, groupNumber, null, isFirstCompositePart, subFieldsLength);
        }
    };

    drawCompositeField(field, metaData, presenter, widgetsList, groupNumber) {
        let that = this;
        if (isMobileDevice()) {
            for (let subField of field.subFields) {
                that.renderField({field: subField, metaData, presenter, widgetsList, compositeField: field, groupNumber: groupNumber});
            }
            return;
        }
        for (let i = 0; i < field.subFields.length; i++) {
            let subField = field.subFields[i];
            that.renderField({
                field: subField, metaData, presenter, widgetsList, compositeField: field, groupNumber: groupNumber,
                isFirstCompositePart: i == 0 && !isMobileDevice(), subFieldsLength: field.subFields.length
            });
        }
    }

    findMetadata(field) {
        let that = this;
        if (!that.questionEditor)
            return null;
        return createFieldMetadata(field);
    }
}

class EditScreenGroupHandler {

    constructor(widgetsList, rootElement) {
        let that = this;
        that.widgetsList = widgetsList;
        that.currentRowCount = 0;
        that.fieldNumber = 0;
        that.rootElement = rootElement;
    }

    /**
     *
     * @param {String} title
     * @param {any} widget
     * @param {namaTypes.EditScreenField} field
     */
    addWidget(field, entityMetaData, presenter, fieldMetadata, compositeField, groupNumber, predefinedWidget,
              isFirstCompositePart, subFieldsLength) {
        let that = this;
        let widget = predefinedWidget;
        if (!widget) {
            if (!fieldMetadata)
                fieldMetadata = meta.findFieldMetadata(field.id, entityMetaData);
            if (!fieldMetadata)
                return "";
            if (!isFeatureEnabled(fieldMetadata.relatedToFeature))
                return "";
            if (fieldMetadata.fieldType === FieldType.Reference && !isFeatureEnabled(fieldMetadata.referencedEntityType))
                return "";
            if (presenter && !userCanViewField(presenter.entityType, field.id))
                return "";
            let req = {fieldMetadata: fieldMetadata, owner: presenter, width: getFieldWidth(field)};
            if (that.rootElement && !req.owner.rootElement)
                req.owner.rootElement = that.rootElement;
            widget = intiWidget_(field, entityMetaData, presenter, fieldMetadata, req);
        }
        let isMobile = isMobileDevice();
        let mustAddLabelOrNewLine = isMobile || !compositeField || isFirstCompositePart;
        if ((that.currentRowCount >= 2 || that.currentRowCount === 0) && mustAddLabelOrNewLine) {
            that.currentRowCount = 0;
            that.addNewLine();
        }
        if (field.layout === EditScreenFieldLayout.alone || field.layout === EditScreenFieldLayout.startnewline || field.layout === EditScreenFieldLayout.spanned || field.layout === EditScreenFieldLayout.spanned2) {
            that.currentRowCount += 2;
            if (that.lastRow.children().length)
                that.addNewLine();
        } else if (isMobile || !isFirstCompositePart)
            that.currentRowCount++;
        let ownerId = entityMetaData && entityMetaData.owner ? entityMetaData.owner.ownerId : null;
        if (mustAddLabelOrNewLine) {
            let label = that.addWidgetLabel(ownerId, field, compositeField, fieldMetadata, groupNumber, predefinedWidget);
            that.lastRow.append(label);
        }
        let divKlass = field.layout === EditScreenFieldLayout.spanned2 || field.layout === EditScreenFieldLayout.spanned ||
        (isFirstCompositePart && !isMobile && subFieldsLength > 2) ? "col-md-10" : "col-md-4";
        let widgetDiv = $(`<div id = ${that.createFieldId(field, groupNumber)} class= "row no-gutters widgetContainer ${divKlass}"></div>`);
        let widgetDivAdded = false;
        if (compositeField && !isMobile) {
            let subFieldKlass = "col-md-" + Math.ceil(12 / subFieldsLength);
            let compFieldIdWithoutDot = compositeField.id.replaceAll(".", "");
            widgetDiv = that.lastRow.find("#" + compFieldIdWithoutDot);
            if (!widgetDiv.length) {
                widgetDiv = $(`<div id = "${compFieldIdWithoutDot}" class= "row no-gutters ${divKlass}"></div>`);
                that.lastRow.append(widgetDiv);
            }
            let subWidgetContainer = $(`<div class= "row no-gutters ${subFieldKlass}"></div>`);
            let subWidgetDiv = $(`<div id = ${that.createFieldId(field, groupNumber)} 
                                  class= "row no-gutters widgetContainer col-md-12"></div>`);
            if (field.hasTitle) {
                subWidgetDiv = $(`<div id = ${that.createFieldId(field, groupNumber)} 
                                  class= "row no-gutters widgetContainer col-md-6"></div>`);
                let subWidgetLabelDiv = that.addWidgetLabel(ownerId, field, null, fieldMetadata, groupNumber, predefinedWidget, "row no-gutters col-md-6");
                subWidgetContainer.append(subWidgetLabelDiv);
            }
            subWidgetContainer.append(subWidgetDiv);
            widgetDiv.append(subWidgetContainer);
            widgetDivAdded = true;
            subWidgetDiv.append(widget.render());
        }
        if (!widgetDivAdded) {
            widgetDiv.append(widget.render());
            that.lastRow.append(widgetDiv);
        }
        that.lastWidget = widget;
    }

    addWidgetLabel(ownerId, field, compositeField, fieldMetadata, groupNumber, editorWidget, labelKlasse) {
        let that = this;
        let required = fieldMetadata.required;
        let title = field.customFieldTitle;
        if (!title) {
            let baseTitle = compositeField ? ts.translateTitledId(ownerId, compositeField) : undefined;
            if (isMobileDevice() || !compositeField) {
                title = ts.translateTitledId(ownerId, field);
                if (baseTitle && baseTitle !== title)
                    title = baseTitle + " - " + title;
            } else {
                title = baseTitle;
            }
        }
        if (editorWidget)
            title = translate(field.id, ownerId);
        ++that.fieldNumber;
        let labelContainer = $(`<div class="${labelKlasse ? labelKlasse : "col-md-2"} col-form-label control-label">
        <a href="#" title="${translateId("help")}" id="helpLink" class="k-icon k-i-help" style="display: none"></a>
        <label class ="fieldLabel" for="${that.createFieldId(field, groupNumber)}">${title}</label></div>`);
        if (required)
            labelContainer.addClass("required-field");
        if (shouldShowHelpMsgs()) {
            let helpLink = labelContainer.find("#helpLink");
            helpLink.css("display", "inline-flex");
            helpLink.on("click", (e) => {
                e.preventDefault();
                /**
                 *
                 * @type {namaTypes.DTOHelpMessagesRequest}
                 */
                let reqData = {
                    fieldId: field.id,
                    entityType: ownerId
                };
                findHelpMsgAndShowIt(reqData);
            });
        }
        return labelContainer;
    }

    createFieldId(field, groupNumber) {
        return field.id + groupNumber + this.fieldNumber;
    }

    addNewLine() {
        let that = this;
        if (that.lastRow && that.lastRow.children().length == 0)
            return;
        that.lastRow = $(`<div class="form-group row"></div>`).appendTo(that.widgetsList);
    }
}


export function newLine() {
    return $(`<div class="clearfix"/>`);
}

export function calcMainFileWidthPercent(entityType) {
    let entityImageInfo = getEntityImageInfo(entityType);
    if (entityImageInfo == null || isNullOrUndefined(entityImageInfo.mainFileWidthPercent) || entityImageInfo.mainFileWidthPercent == 0)
        return 20;
    return entityImageInfo.mainFileWidthPercent;
}
